import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class CursosService {

  allURL = environment.apiURL + 'cms/cursos';
  cursosURL = environment.apiURL + 'cms/cursos/2';
  carrerasURL = environment.apiURL + 'cms/cursos/1';
  terciariasURL = environment.apiURL + 'cms/cursos/3';

  constructor(private http: HttpClient, private router: Router) { }

  //cursos
  getAllCursos(): Observable<any> {
    const url = this.allURL;
    return this.http.get<any[]>(url);
  }

  getCursosById(id): Promise<any> {
    const url = this.allURL + '/' + id;
    return this.http.get<any>(url).toPromise().catch((err) => {
        this.router.navigate(['']);
      });
  }
  getCursosST(): Observable<any> {
    const url = this.cursosURL + '/sistemas';
    return this.http.get<any[]>(url);
  }

  getCursosAV(): Observable<any> {
    const url = this.cursosURL + '/arquitectura';
    return this.http.get<any[]>(url);
  }

  getCursosDC(): Observable<any> {
    const url = this.cursosURL + '/comunicac';
    return this.http.get<any[]>(url);
  }

  getCursosMNA(): Observable<any> {
    const url = this.cursosURL + '/marketing';
    return this.http.get<any[]>(url);
  }

  //carreras
  getCarrerasST(): Observable<any> {
    const url = this.carrerasURL + '/sistemas';
    return this.http.get<any[]>(url);
  }

  getCarrerasAV(): Observable<any> {
    const url = this.carrerasURL + '/arquitectura';
    return this.http.get<any[]>(url);
  }

  getCarrerasDC(): Observable<any> {
    const url = this.carrerasURL + '/comunicac';
    return this.http.get<any[]>(url);
  }

  getCarrerasMNA(): Observable<any> {
    const url = this.carrerasURL + '/marketing';
    return this.http.get<any[]>(url);
  }

  getCarrerasByIdAV(id): Observable<any> {
    const url = this.carrerasURL + '/arquitectura/' + id;
    return this.http.get<any>(url);
  }

  //terciarias
  getTerciariasST(): Observable<any> {
    const url = this.terciariasURL + '/sistemas';
    return this.http.get<any[]>(url);
  }

  getTerciariasAV(): Observable<any> {
    const url = this.terciariasURL + '/arquitectura';
    return this.http.get<any[]>(url);
  }

  getTerciariasDC(): Observable<any> {
    const url = this.terciariasURL + '/comunicac';
    return this.http.get<any[]>(url);
  }

  getTerciariasMNA(): Observable<any> {
    const url = this.terciariasURL + '/marketing';
    return this.http.get<any[]>(url);
  }


}
